import React from "react";

import { NavLink, useLocation } from "react-router-dom";

const TabMenu = props => {
  const { items } = props;
  let location = useLocation();

  console.log(location);

  return (
    <ul className="tab-menu">
      {items.map(item => {
        return (
          <li className="tab-menu__item">
            <NavLink to={item.to} className="tab-menu__link" state={{ title: location.state.title }}>{item.name}</NavLink>
          </li>
        );
      })}
    </ul>
  );
}

export default TabMenu;